import { useEffect } from "react";
import { Navigate, useNavigate, useLocation } from "react-router";
import { logIn } from "../redux/actions/index";
import { useDispatch } from "react-redux";

const Auth = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logIn());

    navigate("/");
  }, [dispatch, navigate, location.search]);

  return <Navigate to="/" />;
};

export default Auth;
